import { useState } from "react";
import "./ThrustAreas.css";


const ThrustAreas = () => {
    const [openDept, setOpenDept] = useState(null);

    const departments = [
        {
            name: "Computer Science",
            areas: [
                "Artificial Intelligence",
                "Machine Learning",
                "Natural Language Processing",
                "Data Analytics",
                "Cloud Computing",
                "Cyber Security"
            ]
        },
        {
            name: "Biotechnology",
            areas: [
                "Plant Biotechnology",
                "Molecular Biology",
                "Genomics",
                "Bioinformatics",
                "Microbial Technology"
            ]
        },
        {
            name: "Physics",
            areas: [
                "Condensed Matter Physics",
                "Space & Atmospheric Research",
                "Quantum Mechanics",
                "Material Science"
            ]
        },
        {
            name: "Chemistry",
            areas: [
                "Organic Synthesis",
                "Analytical Chemistry",
                "Environmental Chemistry",
                "Nano Materials"
            ]
        },
        {
            name: "Engineering",
            areas: [
                "Renewable Energy Systems",
                "Structural Engineering",
                "Robotics & Automation",
                "Smart Infrastructure"
            ]
        },
        {
            name: "Management",
            areas: [
                "Business Analytics",
                "Finance & Accounting",
                "Marketing Management",
                "Human Resource Management",
                "Entrepreneurship"
            ]
        },
        {
            name: "Social Sciences",
            areas: [
                "Rural Development",
                "Economics",
                "Sociology",
                "Psychology",
                "Public Policy"
            ]
        },
        {
            name: "Humanities",
            areas: [
                "Telugu Studies",
                "Literature",
                "History",
                "Philosophy",
                "Linguistics"
            ]
        }
    ];

    return (
        <div>
            


            {/* Collapsible Department Cards */}
            <h4 className="section-title">Department-wise Research Thrust Areas</h4>

            <div className="dept-cards">
                {departments.map((dept, index) => (
                    <div className="dept-card" key={index}>
                        <div
                            className="dept-header"
                            onClick={() =>
                                setOpenDept(openDept === index ? null : index)
                            }
                        >
                            <h5>{dept.name}</h5>
                            <span>{openDept === index ? "−" : "+"}</span>
                        </div>

                        <div className={`dept-body ${openDept === index ? "open" : ""}`}>
                            <ul>
                                {dept.areas.map((area, i) => (
                                    <li key={i}>{area}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default ThrustAreas;